import { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import BrandStatement from '@/components/BrandStatement';
import ServicesSection from '@/components/ServicesSection';
import MoodsSection from '@/components/MoodsSection';
import EstimateCalculator from '@/components/EstimateCalculator';
import ProcessSection from '@/components/ProcessSection';
import TestimonialSection from '@/components/TestimonialSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  const { scrollYProgress } = useScroll();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#F5F0E8]">
      <Header />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.8 }}
      >
        <HeroSection />
        <BrandStatement />
        <ServicesSection />
        <MoodsSection />
        <EstimateCalculator />
        <ProcessSection />
        <TestimonialSection />
        <ContactSection />
      </motion.main>
      
      <Footer />
    </div>
  );
}
